import { header } from "./modules/header";
import { hero } from "./modules/hero";
import { video } from "./modules/video";
import { animateOnScroll } from "./modules/animate-on-scroll";
import { animateDots } from "./modules/animate-dots";
import { detectGgFromConfirmation } from "./modules/detect-gg-from-confirmation";
import { singleVideoFullscreen } from "./modules/signle-video-fullscreen";
import { hasVideoModal } from "./modules/has-video-modal";
import {validateFormOnFrontend} from "./modules/instant-form-validation";

document.addEventListener( 'DOMContentLoaded', function() {
    animateOnScroll();
    header();
    video();
    hero();
    animateDots();
    detectGgFromConfirmation();
    //singleVideoFullscreen ();
    hasVideoModal();
    validateFormOnFrontend();
  }
);